import LetterLoading from "components/loading/letterLoading";
import CloseJobModal from "components/modals/closeJobModal";
import Navigation from "components/navigation";
import Sidebar from "components/sidebar";
import { DeviceContext } from "context/deviceProvider";
import { MaintenanceContext } from "context/maintenanceProvider";
import React, { useContext, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import {
  Accordion,
  Breadcrumb,
  Button,
  Divider,
  Form,
  Header,
  Icon,
  Segment,
  Select,
} from "semantic-ui-react";
import {
  warrantyOptions,
  contactOptions,
  stateOptions,
  unitOfUseOptions,
  problemOptions,
} from "assets/data/maintenanceOptions";
import SemanticDatepicker from "react-semantic-ui-datepickers";
import Swal from "sweetalert2";
import { END_POINT } from "context/endPoint";
import { UserContext } from "context/userProvider";

export default function MaintenanceDetail() {
  const [isLoading, setIsLoading] = useState(false);
  const [closeJob, setCloseJob] = useState(false);
  const [activeDetail, setActiveDetail] = useState(0);
  const [activeImage, setActiveImage] = useState(0);
  const [maintenanceImage, setMaintenanceImage] = useState([]);
  const [repairDetail, setRepairDetail] = useState([]);
  const [partsDetail, setPartsDetail] = useState([]);
  const maintenances = useContext(MaintenanceContext);
  const partsList = useContext(DeviceContext);
  const users = useContext(UserContext);
  const { id } = useParams();

  useEffect(() => {
    setIsLoading(true);
    getMaintenance();
    // setIsLoading(false);
    setTimeout(() => setIsLoading(false), 1000);
  }, []);

  async function getMaintenance() {
    await maintenances.getMaintenance({ state: [] });
    await partsList.getMasterParts({ model: null });

    if (maintenances.maintenanceList.length > 0) {
      const detail = maintenances.maintenanceList.filter(
        (user) => user.id === parseInt(id)
      );
      setRepairDetail(detail[0]);
      setMaintenanceImage(detail[0]?.images?.add);
      // console.log(maintenanceImage);
      await fetchParts(detail[0].partCode);
    }
  }

  async function fetchParts(partCode) {
    const partsFilter = partsList.partsList.filter(
      (parts) => parts.code === partCode
    );
    setPartsDetail(partsFilter[0]);
  }

  const alertDialog = (title, text, icon) => {
    Swal.fire({
      title: title,
      text: text,
      icon: icon,
    }).then((res) => {
      if (res.isConfirmed && icon === "success") {
        return this.props.isClose();
      }
    });
  };

  const onUpdateTime = (date) => {
    let updateDate =
      date
        .toLocaleDateString("ko-KR", {
          year: "numeric",
          month: "2-digit",
          day: "2-digit",
        })
        .replaceAll(". ", "-")
        .replaceAll(".", " ") + date.toTimeString().substring(0, 8);

    return updateDate;
  };

  const handleClick = (e, titleProps) => {
    const { index } = titleProps;
    if (titleProps.name === "userDetail") {
      const newIndex = activeDetail === index ? -1 : index;
      setActiveDetail(newIndex);
    } else {
      const newIndex = activeImage === index ? -1 : index;
      setActiveImage(newIndex);
    }
  };

  const onUpdateMaintenance = async (button) => {
    if (
      repairDetail?.amountOfUse == null ||
      repairDetail?.amountOfUseUnit == null ||
      repairDetail?.fullName == null ||
      repairDetail?.inWarranty == null ||
      repairDetail?.phoneNo == null ||
      repairDetail?.problemDetectionDate == null ||
      repairDetail?.topic == null
    ) {
      return alertDialog("Warning!", "กรุณากรอกข้อมูลให้ครบถ้วน", "Warning");
    }

    const data = {
      model: repairDetail.model,
      amountOfUse: repairDetail.amountOfUse,
      amountOfUseUnit: repairDetail.amountOfUseUnit,
      clpSerial: repairDetail.clpSerial,
      contactChoice: repairDetail.contactChoice,
      fullName: repairDetail.fullName,
      id: repairDetail.id,
      inWarranty: repairDetail.inWarranty,
      note: repairDetail.note,
      periodActiveRange: repairDetail?.periodActiveRange || null,
      phoneNo: repairDetail.phoneNo,
      problemDetectionDate: repairDetail.problemDetectionDate,
      state: button === "approve" ? "received" : repairDetail.state,
      topic: repairDetail.topic,
      workerId: repairDetail.workerId,
      responsibleBy: repairDetail.responsibleBy,
    };

    const formData = new FormData();
    maintenanceImage?.map((image) => formData.append("file", image));
    formData.append("data", JSON.stringify(data));

    console.log("dataupdate",data);
    let result = await maintenances.updateMaintenanceWithImage(formData);
    if (result?.code === 0) {
      return alertDialog("Success!", result?.description, "success");
    } else {
      return alertDialog("Error!", result?.description, "error");
    }

    // console.log("repairDetail");
    // console.log(data);
  };

  const maintenanceDetail = () => {
    // console.log(partsDetail.name_th);
    console.log("ddddd",repairDetail);
    return (
      <Segment>
        <Accordion fluid styled>
          <Accordion.Title
            active={activeDetail === 0}
            index={0}
            name="userDetail"
            onClick={handleClick}
          >
            <Icon name="dropdown" />
            ข้อมูลการแจ้งซ่อม
          </Accordion.Title>
          <Accordion.Content active={activeDetail === 0}>
            {repairUserDetail()}
          </Accordion.Content>
        </Accordion>
        <br />
        <Accordion fluid styled>
          <Accordion.Title
            active={activeImage === -1}
            index={0}
            name="image"
            onClick={handleClick}
          >
            <Icon name="dropdown" />
            ข้อมูลรูปภาพ
          </Accordion.Title>
          <Accordion.Content active={activeImage === -1}>
            {uploadImage()}
          </Accordion.Content>
        </Accordion>
      </Segment>
    );
  };

  const repairUserDetail = () => {
    return (
      <table>
        <tbody>

          {/* <tr>
            <td>
              <label>
                รุ่นเครื่องจักร <span style={{ color: "#ff0000" }}>*</span>
              </label>
            </td>
            <td>
              <Form>
                <Form.Field>
                  <input
                    placeholder="หมายเลขเครื่องจักร"
                    value={repairDetail?.model}
                    readOnly
                  />
                </Form.Field>
              </Form>
            </td>
          </tr> */}

          <tr>
            <td>
              <label>
                หมายเลขเครื่องจักร <span style={{ color: "#ff0000" }}>*</span>
              </label>
            </td>
            <td>
              <Form>
                <Form.Field>
                  <input
                    placeholder="หมายเลขเครื่องจักร"
                    value={repairDetail?.clpSerial}
                    readOnly
                  />
                </Form.Field>
              </Form>
            </td>
          </tr>

          <tr>
            <td>
              <label>
               ชื่อบัญชีผู้ใช้งาน <span style={{ color: "#ff0000" }}>*</span>
              </label>
            </td>
            <td>
              <Form>
                <Form.Field>
                  <input
                    placeholder="ชื่อ-นามสกุล ผู้ใช้งาน"
                    value={repairDetail?.userId || ""}
                    readOnly
                    onChange={(e) =>
                      setRepairDetail({
                        ...repairDetail,
                        userId: e.target.value,
                      })
                    }
                  />
                </Form.Field>
              </Form>
            </td>
          </tr>

          <tr>
            <td>
              <label>
                ชื่อผู้ใช้งาน <span style={{ color: "#ff0000" }}>*</span>
              </label>
            </td>
            <td>
              <Form>
                <Form.Field>
                  <input
                    placeholder="ชื่อผู้ใช้งาน"
                    value={repairDetail?.fullName}
                    readOnly
                    onChange={(e) =>
                      setRepairDetail({
                        ...repairDetail,
                        fullName: e.target.value,
                      })
                    }
                  />
                </Form.Field>
              </Form>
            </td>
          </tr>

          <tr>
            <td>
              <label>
                เบอร์โทรลูกค้า <span style={{ color: "#ff0000" }}>*</span>
              </label>
            </td>
            <td>
              <Form>
                <Form.Field>
                  <input
                    placeholder="เบอร์โทรลูกค้า"
                    value={repairDetail?.phoneNo}
                    readOnly
                    onChange={(e) =>
                      setRepairDetail({
                        ...repairDetail,
                        phoneNo: e.target.value,
                      })
                    }
                  />
                </Form.Field>
              </Form>
            </td>
          </tr>
                  
          <tr>
            <td>
              <label>
                สถานะการรับประกัน <span style={{ color: "#ff0000" }}>*</span>
              </label>
            </td>
            <td>
              <Form>
                <Form.Field>
                  <Select
                    placeholder="สถานะการรับประกัน"
                    value={repairDetail?.inWarranty}
                    
                    options={warrantyOptions}
                    readOnly
                    onChange={(e, { value }) =>
                      setRepairDetail({ ...repairDetail, inWarranty: value })
                    }
                  />
                </Form.Field>
              </Form>
            </td>
          </tr>

          <tr>
            <td>
              <label>
                วันที่เริ่มใช้งาน
              </label>
            </td>
            <td>
              <Form>
                <Form.Field>
                <SemanticDatepicker
                    placeholder="วันที่เริ่มใช้งาน"
                    format="DD-MM-YYYY"
                    readOnly
                    value={
                      repairDetail?.periodActiveRange
                        ? new Date(repairDetail?.periodActiveRange)
                        : null
                    }
                    onChange={(e, { value }) =>
                      setRepairDetail({
                        ...repairDetail,
                        periodActiveRange: onUpdateTime(value),
                      })
                    }
                  />
                </Form.Field>
              </Form>
            </td>
          </tr>
          <tr>

            <td>
              <label>
                วันที่พบปัญหา <span style={{ color: "#ff0000" }}>*</span>
              </label>
            </td>
            <td>
              <Form>
                <Form.Field>
                  <SemanticDatepicker
                    placeholder="วันที่พบปัญหา"
                    format="DD-MM-YYYY"
                    value={ repairDetail?.problemDetectionDate
                        ? new Date(repairDetail?.problemDetectionDate)
                        : null
                    }
                    onChange={(e, { value }) =>
                      setRepairDetail({
                        ...repairDetail,
                        problemDetectionDate: onUpdateTime(value),
                      })
                    }
                  />
                </Form.Field>
              </Form>
            </td>
          </tr>

          <tr>
            <td>
              <label>วิธีการติดต่อ</label>
            </td>
            <td>
              <Form>
                <Form.Group inline>
                  <Select
                    options={contactOptions}
                    placeholder="วิธีการติดต่อ"
                    value={repairDetail?.contactChoice}
                    onChange={(e, { value }) =>
                      setRepairDetail({
                        ...repairDetail,
                        contactChoice: value,
                      })
                    }
                  />
                  &emsp;
                  <input
                    placeholder="ผู้รับเรื่อง"
                    readOnly
                    value={repairDetail?.responsibleBy || ""}
                    onChange={(e) =>
                      setRepairDetail({
                        ...repairDetail,
                        responsibleBy: e.target.value,
                      })
                    }
                  />
                </Form.Group>
              </Form>
            </td>
          </tr>
          <tr>
            <td>
              <label>แจ้งซ่อมอะไหล่</label>
            </td>
            <td>
              <Form>
                <Form.Field>
                  <input
                    placeholder="แจ้งซ่อมอะไหล่"
                    value={partsDetail?.name_th}
                    readOnly
                  />
                </Form.Field>
              </Form>
            </td>
          </tr>
          {/* <tr>
            <td>
              <label>
                ปัญหาแจ้งซ่อม <span style={{ color: "#ff0000" }}>*</span>
              </label>
            </td>
            <td>
              <Form>
                <Form.Field>
                  <Select
                    options={problemOptions}
                    placeholder="ปัญหาแจ้งซ่อม"
                    value={repairDetail?.topic}
                    onChange={(e, { value }) =>
                      setRepairDetail({
                        ...repairDetail,
                        topic: value,
                      })
                    }
                  />
                </Form.Field>
              </Form>
            </td>
          </tr> */}
          <tr>
            <td>
              <label>
                ปริมาณการใช้งาน <span style={{ color: "#ff0000" }}>*</span>
              </label>
            </td>
            <td>
              <Form>
                <Form.Group inline>
                  <input
                    placeholder="ปริมาณการใช้งาน"
                    value={repairDetail?.amountOfUse || ""}
                    onChange={(e) =>
                      setRepairDetail({
                        ...repairDetail,
                        amountOfUse: e.target.value,
                        amountOfUseUnit: "กก./วัน",
                      })
                    }
                    style={{ width: "50%" }}
                  />
                  &emsp;
                  {/* <Select
                    options={unitOfUseOptions}
                    placeholder="ระบุหน่วยการใช้งาน"
                    value={repairDetail?.amountOfUseUnit}
                    onChange={(e, { value }) =>
                      setRepairDetail({
                        ...repairDetail,
                        amountOfUseUnit: value,
                      })
                    }
                  /> */}
                  <label>กก./วัน</label>
                </Form.Group>
              </Form>
            </td>
          </tr>
          <tr>
            <td>
              <label>
                สถานะดำเนินการ <span style={{ color: "#ff0000" }}>*</span>
              </label>
            </td>
            <td>
              <Form>
                <Form.Field>
                  <Select
                    options={stateOptions}
                    placeholder="สถานะดำเนินการ"
                    value={repairDetail?.state}
                    onChange={(e, { value }) =>
                      setRepairDetail({
                        ...repairDetail,
                        state: value,
                      })
                    }
                  />
                  {repairDetail?.state === "later" && (
                    <div className="calendar">
                      <SemanticDatepicker
                        onChange={(e, { value }) =>
                          setRepairDetail({
                            ...repairDetail,
                            appointmentDate: onUpdateTime(value),
                          })
                        }
                      />
                    </div>
                  )}
                </Form.Field>
              </Form>
            </td>
          </tr>
          <tr>
            <td>
              <label>หมายเหตุ</label>
            </td>
            <td>
              <Form>
                <Form.Field>
                  <textarea
                    placeholder="ระบุวัตถุดิบ เช่น พันธุ์ข้าว, ชนิดไม้, ชนิดดิน, ลักษณะแม่น้ำ เป็นต้น"
                    value={repairDetail?.note}
                    onChange={(e) =>
                      setRepairDetail({
                        ...repairDetail,
                        note: e.target.value,
                      })
                    }
                  />
                </Form.Field>
              </Form>
            </td>
          </tr>
        </tbody>
      </table>
    );
  };

  const onSelectImage = (e) => {
    console.log("e.target.files: " + e.target.files.length);
    if (maintenanceImage.length < 5 && e.target.files.length < 6) {
      let files = Array.from(e.target.files).map((image) => image);
      setMaintenanceImage([...maintenanceImage, ...files]);
    } else {
      console.log("ไม่สามารถอัพโหลดรูปภาพได้เกิน 5 รูป");
      // this.onChangeAlert("ไม่สามารถอัพโหลดรูปภาพได้เกิน 5 รูป");
    }
  };

  const removeImage = (name) => {
    const imageFilter = maintenanceImage.filter((image) => image.name !== name);
    setMaintenanceImage(imageFilter);
  };

  const uploadImage = () => {
    // console.log(maintenanceImage);
    return (
      <Segment>
        <Divider horizontal>
          <Header as="h4">
            <Icon name="images" />
            แจ้งซ่อม {maintenanceImage.length}/5
          </Header>
        </Divider>

        <input type="file" multiple onChange={onSelectImage} />
        <div className="addMaintenance">
          {maintenanceImage.length > 0 &&
            maintenanceImage.map((image, idx) => (
              <div key={idx} className="fadein">
                <div onClick={() => removeImage(image.name)} className="delete">
                  <Icon name="times circle" size="large" />
                </div>

                {image.name ? (
                  <img
                    key={`${image.name}-${idx}`}
                    alt="add-maintenance"
                    src={URL.createObjectURL(image)}
                    style={{
                      width: 300,
                      height: 300,
                      objectFit: "cover",
                    }}
                  />
                ) : (
                  <img
                    key={idx}
                    alt="add-maintenance"
                    src={`${END_POINT}/get/image?name=${image.path}`}
                    style={{
                      width: 300,
                      height: 300,
                      objectFit: "cover",
                    }}
                  />
                )}
              </div>
            ))}
        </div>
      </Segment>
    );
  };

  const createButton = () => {
    return (
      <>
        <Button color="blue" onClick={() => onUpdateMaintenance("save")}>
          บันทึก
        </Button>
        &emsp;
        {users.userDetail?.role === "manager" && (
          <Button color="green" onClick={() => onUpdateMaintenance("approve")}>
            อนุมัติ
          </Button>
        )}
      </>
    );
  };

  const updateCloseJob = () => {
    let state = closeJob;
    setCloseJob(!state);
  };

  const sections = [
    { key: "หน้าแรก", content: "หน้าแรก", link: true, href: "/home" },
    { key: "แจ้งซ่อม", content: "แจ้งซ่อม", link: true, href: "/maintenance-list",},
    { key: `${repairDetail?.documentNo}`, content: `${repairDetail?.documentNo}`, active: true,},
  ];

  return (
    <div className="newMaintenance">
      <LetterLoading isOpen={isLoading} />
      <Sidebar tabActive="maintenanceInform" />
      <Navigation />
      <CloseJobModal isOpen={closeJob} isClose={updateCloseJob} />

      <div className="newMaintenance-content">
        <div className="newMaintenance-content-header">
          <h2>แจ้งซ่อม : {repairDetail?.userId}</h2>
          {users.userDetail?.role === "manager" && (
            <Button
              color="red"
              icon="share square"
              label={{
                basic: true,
                color: "red",
                pointing: "left",
                content: "อนุมัติปิดเรื่อง",
              }}
              onClick={() => updateCloseJob()}
            />
          )}
        </div>
        <hr />
        <Breadcrumb icon="right angle" sections={sections} />
        <div className="newMaintenance-content-detail">
          {maintenanceDetail()}
        </div>
        <div className="newMaintenance-content-button">{createButton()}</div>
      </div>
    </div>
  );
}
